import React,{useEffect,useState,Fragment} from 'react';
import {useHistory} from 'react-router-dom';
import {motion} from 'framer-motion';
import { v4 as uuidv4 } from 'uuid';
import styled from 'styled-components';
import Panel from '../components/Panel';
import Content from '../components/Content';
import Expanded from '../components/Expanded';
import Progress from '../components/Progress';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import HomeIcon from '../assets/img/home-icon.svg';


const Question5 = (props) => {

    // const [q5,getQ5] = useState(30);

    let current = new Date().toLocaleTimeString();
    let today = new Date().toISOString().slice(0, 10)
    let subID = uuidv4();;
    const [isAnswered,setIsAnswered] = useState(false);
    const history = useHistory();
    const [isExtraOpen, setIsExtraOpen] = useState(false);

    const getInput = e => {
        const t = e.currentTarget.value;
        props.getQ5(t);
    }

    const checkInput = e => {
        setIsAnswered(true)
        e.preventDefault();
    }


    const sendData = (e) => {
        // e.preventDefault();
        const form = {
          key: `${subID}`,
          date: `${today}`,
          time: `${current}`,
          question1: `${props.q1}`,
          question2: `${props.q2}`,
          question3: `${props.q3}`,
          question4: `${props.q4}`,
          question5: `${props.q5}`
        };
    
        fetch(`https://dev.pk-testing.info/calculatorapi/api/forms/submit/calc_entries?token=615f9a6e3744a8661cc09f0c258b5d`, {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ form })
        })
          .then((e) => e.json())
          .then((res) => {
            console.log("submitted");
          });
        
      };

    return(
        <QuestionPage className="violet">
            <Panel className="violet" setBG="bp4">
                <div className="process-title">business process #5</div>
                </Panel>
            {!isAnswered ?
                    <Content preAns isExtraOpen={isExtraOpen} setIsExtraOpen={setIsExtraOpen}>
                    <h1 className="main-q">manual remediation</h1>
                    <h2 className="question-title">What is your average time for manual remediation of order fallouts?</h2>
                    <form onSubmit={checkInput} action="">
                        <br></br>    
                        <br></br>      
                        <input className="default-slider seconds" required onChange={getInput} type="range" min="1" max="60" value={props.q5 == undefined || null ? '30' : props.q5} />  <LivePerc>{props.q5 == undefined || null ? '30' : props.q5}{props.q5 == 1 ? ' minute' : ' minutes'} </LivePerc>
                        <br></br>
                        <CalculateButton />
                    </form>
                </Content>

                :
                <Content preAns={false} isExtraOpen={isExtraOpen} setIsExtraOpen={setIsExtraOpen}>
                    {props.q5 > 25 ?
                    <Fragment>
                        <motion.div initial={{opacity:1,y:'150%'}} animate={{opacity:1,y: '0',transition:{duration:1}}} exit={{opacity:0}}>
                        <h1 className="main-q">manual remediation</h1>
                        <div className="determined-benchmark">You are <span>ahead</span> of the industry benchmark</div>
                        <TextInfo>
                            <div>
                                <p>The ability to provide a more seamless customer experience is a key strategic advantage. We found that in our industry, manual remediation of fallouts takes 25 minutes on average, with Amdocs customers typically achieving 12.5 minutes. Quick remediation is key to stopping further degradation of the customer experience following a fallout. Even better is proactive identification and remediation, which can prevent a customer from ever knowing a fallout on an order occurred, ensuring the provisioning process has no negative effect at all on the customer experience.</p>
                            </div>
                        </TextInfo>
                        </motion.div>  
                        <Expanded isExtraOpen={isExtraOpen} setIsExtraOpen={setIsExtraOpen}>
                        <h1>how Amdocs can help</h1>
                        <p>With our iPaaS-powered business process and integration services, we run database scripts coupled with RPA to automate key background business processes to enable increased effectiveness and cost efficiencies. We also help agents to eliminate “swivel chair” activity by providing all relevant information and execution on one screen – effectively, one source of truth. Our services are led by a team of Amdocs experts, focusing on industry-specific business processes such as ordering, care and billing on any internal or external channel. Amdocs also deploys iPaaS and various predictive analytics to proactively identify and remedy a fallout before it impacts the customer, thereby avoiding any negative customer experience.</p>
                        <NextPage onClick={()=>{history.push('/thank-you'); sendData();}}>complete <NextArrow icon={faArrowRight}/></NextPage>
                    </Expanded>        
                        
                    </Fragment>

                    : props.q5 == 25 ?
                    <Fragment>
                        <motion.div initial={{opacity:1,y:'150%'}} animate={{opacity:1,y: '0',transition:{duration:1}}} exit={{opacity:0}}>
                        <h1 className="main-q">manual remediation</h1>
                        <div className="determined-benchmark">You are <span>exactly</span> in line with the industry benchmark</div>
                        <TextInfo>
                            <div>
                                <p>The ability to provide a more seamless customer experience is a key strategic advantage. We found that in our industry, manual remediation of fallouts takes 25 minutes on average, with Amdocs customers typically achieving 12.5 minutes. Quick remediation is key to stopping further degradation of the customer experience following a fallout. Even better is proactive identification and remediation, which can prevent a customer from ever knowing a fallout on an order occurred, ensuring the provisioning process has no negative effect at all on the customer experience.</p>
                            </div>
                        </TextInfo>
                        </motion.div>  
                        <Expanded isExtraOpen={isExtraOpen} setIsExtraOpen={setIsExtraOpen}>
                    <h1>how Amdocs can help</h1>
                    <p>With our iPaaS-powered business process and integration services, we run database scripts coupled with RPA to automate key background business processes to enable increased effectiveness and cost efficiencies. We also help agents to eliminate “swivel chair” activity by providing all relevant information and execution on one screen – effectively, one source of truth. Our services are led by a team of Amdocs experts, focusing on industry-specific business processes such as ordering, care and billing on any internal or external channel. Amdocs also deploys iPaaS and various predictive analytics to proactively identify and remedy a fallout before it impacts the customer, thereby avoiding any negative customer experience.</p>
                        <NextPage onClick={()=>{history.push('/thank-you'); sendData();}}>complete <NextArrow icon={faArrowRight}/></NextPage>
                    </Expanded>                
                    </Fragment>
                    : props.q5 < 25 ?
                    <Fragment>
                    <motion.div initial={{opacity:1,y:'150%'}} animate={{opacity:1,y: '0',transition:{duration:1}}} exit={{opacity:0}}>
                    <h1 className="main-q">cost per order</h1>
                        <div className="determined-benchmark">You are <span>behind</span> the industry benchmark</div>
                        <TextInfo>
                            <div>
                                <p>The ability to provide a more seamless customer experience is a key strategic advantage. We found that in our industry, manual remediation of fallouts takes 25 minutes on average, with Amdocs customers typically achieving 12.5 minutes. Quick remediation is key to stopping further degradation of the customer experience following a fallout. Even better is proactive identification and remediation, which can prevent a customer from ever knowing a fallout on an order occurred, ensuring the provisioning process has no negative effect at all on the customer experience.</p>
                            </div>
                        </TextInfo>
                        </motion.div>  
                        <Expanded isExtraOpen={isExtraOpen} setIsExtraOpen={setIsExtraOpen}>
                    <h1>how Amdocs can help</h1>
                    <p>With our iPaaS-powered business process and integration services, we run database scripts coupled with RPA to automate key background business processes to enable increased effectiveness and cost efficiencies. We also help agents to eliminate “swivel chair” activity by providing all relevant information and execution on one screen – effectively, one source of truth. Our services are led by a team of Amdocs experts, focusing on industry-specific business processes such as ordering, care and billing on any internal or external channel. Amdocs also deploys iPaaS and various predictive analytics to proactively identify and remedy a fallout before it impacts the customer, thereby avoiding any negative customer experience.</p>

                        <NextPage onClick={()=>{history.push('/thank-you'); sendData();}}>complete <NextArrow icon={faArrowRight}/></NextPage>
                    </Expanded>                
                    </Fragment>
                    : 
                    <Fragment></Fragment>
                    }
                </Content>
            }
           
           <Progress prog={100} />

        </QuestionPage>
    )
}

const QuestionPage = styled(motion.div)`
    width: 100%;
    height: 100%;
    overflow-x: hidden !important;
    display: flex;

    @media (max-width: 1060px) {
        flex-direction: column;
        /* height: 100vh; */
    }
`;

const IndustryBenchmark = styled.h3`
    font-family: 'MarkPro-ExtraLight';
    margin-bottom: 20px;
`;

const TextInfo = styled.div`
    display: flex;

    div{
        flex: 1;
        margin-right: 50px;
    }

`;


const NextPage = styled.div`
   font-family: 'MarkPro-Bold';
    color: #fff;
    background: #EAB330;
    text-align: center;
    position: fixed;
    bottom: 60px;
    right: 0;
    font-size: 1.5em;
    padding: 15px;
    cursor: pointer;
    z-index:1000;

    @media (max-width: 1060px) {
        display: block;
        position: static;
        margin-top: 30px;
    }

`;

const NextArrow = styled(FontAwesomeIcon)`
    margin-left: 10px;
`;



const CalculateButton = styled.input.attrs({ 
    type: 'submit',
    value: 'submit'
  })`
    background: #333147;
    color: #fff;
    cursor: pointer;
    margin-bottom: 0;
    border-color: transparent;
    box-shadow: 0px;
    outline: none;
    text-align: center;
    font-family: 'MarkPro-Bold';
    padding: 10px;
    font-size: 1.3em;
    width: 130px;
    margin-top: 30px;
  `


const LivePerc = styled.span`
    font-family: 'MarkPro-Bold';
    font-size: 2em;
    margin-left: 30px;

    @media (max-width: 1060px) {
        margin-left: 0;
    }
`;


const DummyContainer = styled(motion.div)`
    display: contents;
`;

const HomeButton = styled.div`
    display: block;
    width: 70px; 
    height: 70px;
    border-radius: 100px;
    position: absolute;
    top: 20px;
    left: 20px;
    background: url(${HomeIcon}) no-repeat center center;
    background-size: 60%;
    background-color: #333147;
    cursor: pointer;

    @media (max-width: 1060px) {
        width: 62px;
        height: 62px;
    }
`;

export default Question5;